<template>
  <div class="flex w-60 flex-wrap items-center gap-3">
    <number-field
      v-model="scheduleVal.interval"
      :min="1"
      :max="99"
      :disabled="props.disabled"
      :name="t('interval_repeat_count')"
    />
    <selects
      v-model="scheduleVal.unit"
      :items="items"
      :name="t('cycle')"
      :disabled="props.disabled"
    />
    <div class="w-full">
      <date-range
        v-model="scheduleVal.startAt"
        :min="min"
        :disabled="props.disabled"
        :show-ranges="false"
        :name="t('time')"
        time-picker
        single-date-picker
      />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import dayjs from '@/plugins/dayjs.js';

import numberField from '@/components/general/NumberField.vue';
import selects from '@/components/general/Selects.vue';
import dateRange from '@/components/general/DateRange.vue';

import { ref, watch, defineComponent } from 'vue';
export default defineComponent({
  name: 'GeneralSchedule',
  components: {
    numberField,
    selects,
    dateRange
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        unit: '',
        interval: '',
        startAt: ''
      })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const items = [
      { text: t('day'), value: 'day' },
      { text: t('weak'), value: 'weak' },
      { text: t('month'), value: 'month' },
      { text: t('year'), value: 'year' }
    ];

    const min = dayjs().format('YYYY-MM-DD HH:00');

    const scheduleVal = ref({
      unit: props.modelValue.unit || 'day',
      interval: props.modelValue.interval || 1,
      startAt: props.modelValue.startAt || min
    });

    watch(
      () => scheduleVal.value,
      (data) => {
        if (data) {
          emit('update:modelValue', data);
        }
      },
      {
        deep: true,
        immediate: false
      }
    );

    return {
      props,
      t,
      items,
      min,
      scheduleVal
    };
  }
});
</script>